// removed by extract-text-webpack-plugin
module.exports = {"uploadFile":"XhJzyiLU95JA4t0-pS_wH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadFile.less
// module id = 1622
// module chunks = 0